var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dropdown d-none d-lg-inline-block ml-1"},[_c('button',{staticClass:"btn header-item noti-icon",attrs:{"type":"button"},on:{"click":_vm.initFullScreen}},[_c('i',{staticClass:"bx bx-fullscreen"})])])}
var staticRenderFns = []

export { render, staticRenderFns }